import { COLORS } from '../../../../../utils/colors';

export const useAvailableTimeStyles = () => {
  return {
    dayIcon: {
      borderRadius: '3rem',
      border: `1px solid ${COLORS.MEDIUM_GRAY}`,
      padding: '0.8rem',
      minWidth: '54px',
      textAlign: 'center',
      cursor: 'pointer',
      fontSize: '18px',
      fontWeight: '500',
      '&:hover': {
        backgroundColor: COLORS.MEDIUM_GRAY,
        color: '#fff',
      },
    },
    dayIconSelected: {
      borderRadius: '3rem',
      border: `1px solid ${COLORS.MEDIUM_GRAY}`,
      padding: '0.8rem',
      minWidth: '54px',
      textAlign: 'center',
      cursor: 'pointer',
      fontSize: '18px',
      fontWeight: '500',
      color: '#fff',
      backgroundColor: COLORS.MEDIUM_GRAY,
    },
    tableRow: {
      display: 'none',
      '&:hover': {
        display: 'block',
      },
    },
    select: {
      width: '100%',
    },

    formControl: {
      marginBottom: '2rem',
    },

    dayOuterGrid: {
      display: 'flex',
      alignItems: 'baseline',
      marginBottom: '1rem',
    },
    dayInnerGrid: {
      marginRight: '1rem',
      display: 'flex',
      alignItems: 'center',
    },

    flexCenter: {
      display: 'flex',
      alignItems: 'center',
    },
    addButton: {
      margin: '0 1rem',
      minWidth: 'unset',
      padding: '.375rem .75rem',
      backgroundColor: COLORS.WHITE,
      color: 'rgba(0, 0, 0, 0.23);',
      border: `1px solid rgba(0, 0, 0, 0.23);`,
      '&: hover': {
        border: `1px solid ${COLORS.PRIMARY}`,
        backgroundColor: COLORS.PRIMARY,
        color: COLORS.WHITE,
      },
    },
    removeButton: {
      height: '2rem',
      width: '2rem',
      color: COLORS.PRIMARY,
    },
    hoursText: {
      display: 'flex',
      alignItems: 'center',
      textAlign: 'center',
      paddingTop: '0.25rem',
      paddingBottom: '0.25rem',
      justifyContent: 'center',
      height: '3.5625rem',
    },
    addAvailabilityButton: {
      width: '15rem',
      borderRadius: '2rem',
      border: '1px solid #ccc',
      fontSize: '1rem',
      padding: '.5rem',
    },
  };
};
